import apiClient from "../helpers/api-client";

export const registerPassKeyChallenge = async ({
  email,
}: {
  email: string;
}) => {
  return await apiClient.post(`/auth/register-challenge`, { email });
};

export const registerPassKey = async ({
  credential,
  email,
}: {
  credential: any;
  email: string;
}) => {
  return await apiClient.post(`/auth/register-passkey`, { credential, email });
};

export const loginPassKey = async ({
  credential,
  email,
}: {
  credential: any;
  email: string;
}) => {
  return await apiClient.post(`/auth/login-passkey`, { credential, email });
};

export const loginChallenge = async ({ email }: { email: string }) => {
  return await apiClient.post("/auth/login-challenge", { email });
};
